import React, { useEffect, useState } from 'react';
import Fuse from 'fuse.js';
import BackButton from '../components/BackButton';
import MobileNav from '../components/MobileNav';
import { useNavigate } from 'react-router-dom';

export default function Search() {
    const navigate = useNavigate();

    const [channels, setChannels] = useState([]);
    const [query, setQuery] = useState('');
    const [isSearching, setIsSearching] = useState(false);
    const [results, setResults] = useState([]);
    const [hasSearched, setHasSearched] = useState(false);

    useEffect(() => {
        const data = sessionStorage.getItem('PK_Data');
        if (data) {
            const parsed = JSON.parse(data);
            setChannels(parsed.channels || []);
        }
    }, []);

    const handleSearch = () => {
        setIsSearching(true);
        setHasSearched(true);

        const matchedResults = [];

        channels.forEach((channel) => {
            const matchedVideos = [];

            (channel.playlists || []).forEach((playlist) => {
                const fuse = new Fuse(playlist.content || [], {
                    keys: ['title', 'description'],
                    threshold: 0.4,
                });

                const matched = fuse.search(query).map(res => ({
                    video: res.item,
                    playlist,
                }));

                matchedVideos.push(...matched);
            });

            if (matchedVideos.length > 0) {
                matchedResults.push({
                    ...channel,
                    matchedVideos,
                });
            }
        });

        setTimeout(() => {
            setResults(matchedResults);
            setIsSearching(false);
        }, 400);
    };

    const highlight = (text) => {
        if (!query) return text;
        const regex = new RegExp(`(${query})`, 'gi');
        return text.split(regex).map((part, i) =>
            part.toLowerCase() === query.toLowerCase() ? (
                <span key={i} style={{ backgroundColor: 'yellow' }}>{part}</span>
            ) : (
                part
            )
        );
    };

    const handleCardClick = (video, playlist) => {
        const user = localStorage.getItem('PK_user');
        if (!user) {
            const modal = new window.bootstrap.Modal(document.getElementById('loginModal'));
            modal.show();
        } else {
            navigate(`/video`, { state: { video, playlist } });
        }
    };

    const renderSearchResults = () => {
        return results.map((channel) => (
            <div
                key={channel.name}
                className="ps-4 mt-5 d-flex flex-column gap-4"
                style={{ borderLeft: '2px solid var(--main-red)' }}>
                <h5 className="text-danger m-0 bold">{channel.name}</h5>
                {channel.matchedVideos.map(({ video, playlist }) => (
                    <div
                        key={video.title + Math.random()}
                        onClick={() => handleCardClick(video, playlist)}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '0.5rem',
                            cursor: 'pointer',
                        }}
                    >
                        <img className="channel-image" src={video.imageFile} alt={video.title} />
                        <div className="d-flex flex-column align-items-between" style={{ height: '100%' }}>
                            <h6 className="channel-title">{highlight(video.title)}</h6>
                            <p className="channel-description">{highlight(video.description)}</p>
                        </div>
                    </div>
                ))}
            </div>
        ));
    };

    const renderChannelList = () => {
        return channels.map((channel, index) => (
            <div onClick={() => window.location.href=`/?channel=${index}`} // Assuming you want to navigate to the channel page
                key={channel.name}
                className="mt-3 channel-card" >
                <img className='channel-image' src={channel.profileImage} />
                <div>
                    <h5 className="text-danger">{channel.name}</h5>
                    <p className='channel-description' >{channel.description}</p>
                </div>
            </div>
        ));
    };

    return (
        <section className="body_section">
            <BackButton />
            <div style={{ marginBottom: '6rem' }}>
                <h2 className="my-2 bold">Search</h2>
                <p>Search for your favorite playlists, categories, and more</p>

                <div className="d-flex flex-row gap-2">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search for videos, channels, playlists..."
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                    <button className="btn btn-primary" onClick={handleSearch}>
                        Search
                    </button>
                </div>

                {isSearching && (
                    <div className="mt-3">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}

                {!isSearching && (
                    <>
                        <h4 className="mt-4">{hasSearched ? 'Results' : 'Channels'}</h4>
                        {hasSearched
                            ? (results.length > 0 ? renderSearchResults() : <p>No results found.</p>)
                            : renderChannelList()}
                    </>
                )}
            </div>
            <MobileNav />
        </section>
    );
}
